// extracted by mini-css-extract-plugin
module.exports = {"desktopInputRoot":"TopbarSearchForm_desktopInputRoot__1x_g4","languageSelect":"TopbarSearchForm_languageSelect__3fZnD","searchLink":"TopbarSearchForm_searchLink__3Qgr1"};